/*
 * Simple Image
 *
 * Supports:
 * - Retina
 * - Lazy loading of full resolution src
 * - Webp src for suitable browsers
 */

import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/media.d.ts').SimpleImage}
 */
export const SimpleImage = ({
    alt,
    className,
    fetchPriority = 'auto',
    height,
    loading = 'lazy',
    psrc,
    px2,
    role,
    src,
    style,
    width,
    x2
}) => {
    return (
        <img
            alt={alt}
            className={className}
            fetchPriority={fetchPriority}
            height={height}
            loading={loading}
            role={role}
            src={psrc || src}
            srcSet={((px2) || x2) ? `${px2 || x2} 2x` : null}
            style={style}
            width={width} />
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default SimpleImage;
